import Icon from '@material-ui/icons/Category';
import List from './SupplyTypeList';
import Create from './SupplyTypeCreate';
import Edit from './SupplyTypeEdit';

export default {
    list: List,
    create: Create,
    edit: Edit,
    icon: Icon,
};
